"use client";

import { flushSync } from "react-dom";

export const STOCK_LOADING_MESSAGE = "Loading stock…";

export function triggerStockLoading(
  setLoading: (loading: boolean) => void,
  setLoadingMessage: (message: string) => void,
) {
  flushSync(() => {
    setLoadingMessage(STOCK_LOADING_MESSAGE);
    setLoading(true);
  });
}

/** Returns the stock anchor for a click/hover, or null if the target is an inner control. */
export function getStockLinkFromEvent(target: EventTarget | null): HTMLAnchorElement | null {
  if (!(target instanceof Element)) return null;
  if (target.closest('button, [role="button"], input, textarea, select')) return null;

  const anchor = target.closest("a[href^='/stock/']");
  if (!anchor || anchor.getAttribute("target") === "_blank") return null;

  return anchor as HTMLAnchorElement;
}

export function isModifiedMouseEvent(e: MouseEvent | React.MouseEvent): boolean {
  return e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || e.button !== 0;
}

export function stockPathForTicker(fullTicker: string, tickerToSlug: (t: string) => string): string {
  return `/stock/${tickerToSlug(fullTicker)}`;
}

export function shouldNavigateToStock(href: string): boolean {
  if (typeof window === "undefined") return false;
  return href !== window.location.pathname;
}

/** Open a stock page in a new tab (radar/screener default). */
export function openStockInNewTab(href: string): void {
  if (typeof window === "undefined") return;
  window.open(href, "_blank", "noopener,noreferrer");
}

/** Normal click → new tab; modified click / middle button → browser default. */
export function handleStockLinkClick(
  e: React.MouseEvent<HTMLAnchorElement>,
  href: string,
): void {
  if (isModifiedMouseEvent(e)) return;
  e.preventDefault();
  openStockInNewTab(href);
}
